





















































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import EventsBookingDetails from "../events/EventsBookingDetails.vue";

import ListMailAddresses from "../general/ListMailAddresses.vue";

import SettingsJson from "../../shared/SettingsJson";
import ContactJson from "../../shared/ContactJson";
import EventJson from "../../shared/EventJson";
import EventBookingJson from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventWithBookingJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

import GeneralInfos from "../custom/GeneralInfos";

export default Vue.extend({
  name: "EventsParticipants",
  components: {
    Loading,
    TableView,
    ListMailAddresses,
    EventsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    appFrameClickedButton: Object,
    eventIdToShow: Number,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      UserPermissionRank: UserPermissionRank,
      GeneralInfos: GeneralInfos,
      EventBookingStatusNames: EventBookingStatusNames,
      showMailAddressesList: false,
      bookedMailAddressesList: [] as string[],
      showDetails: false,
      detailsMode: "read",
      allEvents: null as EventJson[] | null,
      eventsMoreAvailable: null as boolean | null,
      selectedEventWithBookings: null as EventWithBookingsJson | null,
      selectedEventId: null as number | null,
      selectedEventBookingId: null as number | null,
      showOldEvents: false as boolean,
      loadingConfirmation: false as boolean,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.reloadData();
      }
    },

    openDetails(item: EventWithBookingJson | null, mode: string) {
      if (this.selectedEventId != null) {
        if (item != null) {
          this.selectedEventBookingId = item.ID;
        } else {
          this.selectedEventBookingId = null;
        }

        this.detailsMode = mode;
        this.toggleDetails();
      } else {
        alert("Es muss zuerst eine Veranstaltung ausgewählt werden.");
      }
    },
    /*** END: details view ***/

    async loadData() {
      await this.loadAllEvents();
      if (this.eventIdToShow) {
        this.selectedEventId = this.eventIdToShow;
        this.loadSelectedEventWithBookings();
      }
    },

    async loadAllEvents(loadMore: null = null) {
      this.selectedEventId = null;
      this.selectedEventBookingId = null;
      this.selectedEventWithBookings = null;

      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.allEvents != null) {
        this.eventsMoreAvailable = null;
        skipAmount = this.allEvents.length;
      } else {
        this.allEvents = null;
      }

      if (this.restClient != null) {
        try {
          let events = await this.restClient.getEvents(
            null,
            false,
            false,
            false,
            null,
            null,
            null,
            null,
            false,
            skipAmount
          );

          if (loadMore && this.allEvents != null) {
            this.allEvents = this.allEvents.concat(events.events);
          } else {
            this.allEvents = events.events;
          }

          this.eventsMoreAvailable = events.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadSelectedEventWithBookings() {
      if (this.allEvents != null) {
        this.selectedEventWithBookings = null;

        if (this.restClient != null && this.selectedEventId != null) {
          try {
            this.selectedEventWithBookings = await this.restClient.getEventWithBookings(this.selectedEventId);
          } catch (e) {
            alert(e.message);
          }
        }
      }
    },

    async sendBookingConfirmation(bookingId: number) {
      if (this.selectedEventId != null && bookingId != null && this.restClient != null) {
        this.loadingConfirmation = true;

        try {
          await this.restClient.confirmEventBooking(this.selectedEventId, bookingId);
          alert("Die Anfrage wurde gebucht und es wurde eine Bestätigung an den Kunden gesendet.");
          this.loadingConfirmation = false;
          this.loadSelectedEventWithBookings();
        } catch (e) {
          this.loadingConfirmation = false;
          alert(e.message);
        }
      }
    },

    //print list
    printSelectedEventBookingsList() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    sendMailToBooked() {
      if (this.bookedEventBookings != null) {
        this.bookedMailAddressesList = [];
        var mailtoString = "mailto:" + GeneralInfos.email;

        mailtoString += "?bcc=";

        for (let i = 0; i < this.bookedEventBookings.length; i++) {
          if (this.bookedEventBookings[i].contact) {
            let mailAddress = this.bookedEventBookings[i].contact!.email;

            if (!this.bookedMailAddressesList.includes(mailAddress)) {
              this.bookedMailAddressesList.push(mailAddress);
            }
          }
        }

        mailtoString += this.bookedMailAddressesList.join(";");

        if (mailtoString.length < 2048) {
          window.location.href = mailtoString;
          //window.open(mailtoString, "_blank")
        } else {
          alert(
            "Die E-Mail Vorlage an alle Teilnehmenden konnte leider nicht automatisch erstellt werden. Im folgenden werden die E-Mail Adressen zum kopieren angezeigt."
          );
          this.showMailAddressesList = true;
        }
      }
    },

    async reloadData() {
      this.loadSelectedEventWithBookings();
    },

    getAllParticipantNames(participants: ContactJson[]) {
      var names = "";

      for (let i = 0; i < participants.length; i++) {
        if (i != 0) {
          names += ", ";
        }
        names += participants[i].firstName;
        names += " ";
        names += participants[i].lastName;
      }

      return names;
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }

      if (button == "sendBookingConfirmation") {
        this.sendBookingConfirmation(item.ID);
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.reloadData();
      }
    },
  },
  computed: {
    permissionAbleManagement: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    filteredEvents(): EventJson[] | null {
      if (this.allEvents != null && !this.showOldEvents) {
        let today = new Date();
        let filtered = this.allEvents.filter((i: any) =>
          i.dates ? new Date(i.dates[i.dates.length - 1].endDateTime) > today : true
        );

        return filtered;
      } else {
        return this.allEvents;
      }
    },

    eventColumns: function (): TableViewColumnDefinitions<EventBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) => (i.contact && i.contact.lastName != "" ? i.contact.lastName + ", " + i.contact.firstName : "--"),
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) => (i.participants && i.participants.length > 0 ? vue.getAllParticipantNames(i.participants) : "--"),
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventBookingJson>[];
    },

    eventWaitinglistColumns: function (): TableViewColumnDefinitions<EventBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name (Erziehungsberechtigte:r)",
          td: (i) => (i.contact && i.contact.lastName != "" ? i.contact.lastName + ", " + i.contact.firstName : "--"),
        },
        {
          th: "Name (Teilnehmende:r)",
          td: (i) => (i.participants && i.participants.length > 0 ? vue.getAllParticipantNames(i.participants) : "--"),
        },
        {
          th: "Angefragt",
          td: (i) => DateFormatter.formatDateTime(new Date(i.bookingDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.EventBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Aufrücken und benachrichtigen",
          style: (i) => "text-align:right",
          button: "sendBookingConfirmation",
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<EventBookingJson>[];
    },

    requestedEventBookings(): EventBookingJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = ["incomplete", "requested"];
        let requestedEventBookings = this.selectedEventWithBookings.bookings.filter((i) => states.includes(i.state));
        return requestedEventBookings;
      }
    },

    bookedEventBookings(): EventBookingJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = [
          "bookedReadyForDepositPayment",
          "bookedDepositPaymentExported",
          "readyForPayment",
          "paymentExported",
        ];
        let requestedEventBookings = this.selectedEventWithBookings.bookings.filter((i) => states.includes(i.state));
        return requestedEventBookings;
      }
    },

    waitingListEventBookings(): EventBookingJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = ["waitingList"];
        let requestedEventBookings = this.selectedEventWithBookings.bookings.filter((i) => states.includes(i.state));
        return requestedEventBookings;
      }
    },

    selectedEventRegistrationsLeftText(): string {
      if (this.selectedEventWithBookings != null) {
        const maxRegistrationCount = this.selectedEventWithBookings.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.selectedEventWithBookings.bookings.length; i++) {
          if (
            this.selectedEventWithBookings.bookings[i].state != "requested" &&
            this.selectedEventWithBookings.bookings[i].state != "canceled" &&
            this.selectedEventWithBookings.bookings[i].state != "cancellationFeeExported" &&
            this.selectedEventWithBookings.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    selectedEventWaitingListLeftText(): string {
      if (this.selectedEventWithBookings != null) {
        const maxWaitingListCount = this.selectedEventWithBookings.waitingListMaximumCount;
        let waitingListCount = 0;

        for (let i = 0; i < this.selectedEventWithBookings.bookings.length; i++) {
          if (this.selectedEventWithBookings.bookings[i].state == "waitingList") {
            waitingListCount++;
          }
        }

        if (maxWaitingListCount === undefined) {
          return "Warteliste: [Fehler]";
        }

        let waitingListLeft = maxWaitingListCount - waitingListCount;

        if (waitingListLeft < 0) {
          return "Warteliste: Überbucht";
        } else if (waitingListLeft == 1) {
          return "Warteliste: 1 Platz frei";
        } else {
          return "Warteliste: " + waitingListLeft + " Plätze frei";
        }
      }

      return "Lade Warteliste...";
    },

    sortedBookedEventBookingsByParticipantLastName(): ContactJson[] | null | undefined {
      if (this.selectedEventWithBookings != null) {
        var states = [
          "bookedReadyForDepositPayment",
          "bookedDepositPaymentExported",
          "readyForPayment",
          "paymentExported",
          "paymentReceived",
        ];
        let bookedEventBookings = this.selectedEventWithBookings.bookings.filter((i: EventBookingJson) =>
          states.includes(i.state)
        );

        var participants = [];

        for (let i = 0; i < bookedEventBookings.length; i++) {
          if (bookedEventBookings[i].participants) {
            for (let j = 0; j < bookedEventBookings[i].participants!.length; j++) {
              var newObj: any = {};

              let k = bookedEventBookings[i].participants![j];
              let index: keyof typeof k;

              for (index in bookedEventBookings[i].participants![j]) {
                newObj[index] = bookedEventBookings[i].participants![j][index];
              }

              participants.push(newObj);
            }
          }
        }

        participants.sort(function (a, b) {
          let nameA = a.lastName.toLowerCase();
          let nameB = b.lastName.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });

        return participants;
      }
    },
  },
});
